import React from 'react'
import AppToggle from '../../../../components/AppToggle'

export default function LeadFieldRow({
  fieldKey,
  fieldData,
  defaultName,
  onChange,
  disabledShow = false,
}) {
  if (!fieldData) return null

  return (
    <div className="grid grid-cols-12 gap-3 sm:gap-4 items-center py-2.5 border-b border-outline-variant/15 last:border-b-0">
      {/* ── Column 1: Show Toggle & Default Title (4 cols) ── */}
      <div className="col-span-12 sm:col-span-4 flex items-center gap-3">
        <div onClick={(e) => e.stopPropagation()}>
          <AppToggle
            checked={fieldData.show}
            disabled={disabledShow}
            onChange={(val) => onChange(fieldKey, 'show', val)}
            ariaLabel={`Enable ${defaultName}`}
          />
        </div>
        <span
          className={`text-xs font-bold transition-colors ${
            fieldData.show ? 'text-on-surface' : 'text-on-surface-variant line-through opacity-60'
          }`}
        >
          {defaultName}
        </span>
      </div>

      {/* ── Column 2: Custom Label Input (5 cols) ── */}
      <div className="col-span-12 sm:col-span-5">
        <input
          type="text"
          disabled={!fieldData.show}
          placeholder={`Custom label for ${defaultName}`}
          value={fieldData.label}
          onChange={(e) => onChange(fieldKey, 'label', e.target.value)}
          className="h-9 w-full rounded-xl border border-outline-variant/30 bg-surface-container-low px-3 text-xs font-semibold text-on-surface outline-none focus:border-primary disabled:opacity-40 disabled:bg-surface-container-high"
        />
      </div>

      {/* ── Column 3: Mandatory Toggle (3 cols) ── */}
      <div className="col-span-12 sm:col-span-3 flex items-center justify-end sm:justify-start gap-2.5">
        <span
          className={`text-[11px] font-bold uppercase tracking-wider ${
            fieldData.mandatory && fieldData.show ? 'text-rose-600' : 'text-on-surface-variant'
          }`}
        >
          Mandatory
        </span>
        <div onClick={(e) => e.stopPropagation()}>
          <AppToggle
            checked={fieldData.mandatory && fieldData.show}
            disabled={!fieldData.show}
            onChange={(val) => onChange(fieldKey, 'mandatory', val)}
            ariaLabel={`Mandatory ${defaultName}`}
          />
        </div>
      </div>
    </div>
  )
}
